"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DashOutline = {
    name: 'dash',
    theme: 'outline',
    nameWithTheme: 'dash-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: { d: 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z' },
            children: []
        }
    ]
};
exports.default = DashOutline;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/outline/DashOutline.js
// module id = 738
// module chunks = 0